/**
 * Runtime caches that earlier service worker versions created and that no
 * route in vite.config.ts writes to any more. Workbox's `cleanupOutdatedCaches`
 * only prunes precaches, so these stay on disk — and keep counting against the
 * storage quota — until they are deleted explicitly.
 */
const OBSOLETE_CACHE_NAMES = new Set([
  "locale-cache",
  "images-cache",
  "api-cache",
  "mock-api-cache",
  "google-maps-api",
]);

export async function deleteObsoleteRuntimeCaches(
  cacheStorage: CacheStorage | undefined
): Promise<string[]> {
  if (!cacheStorage) {
    return [];
  }

  const existing = await cacheStorage.keys();
  const obsolete = existing.filter((name) => OBSOLETE_CACHE_NAMES.has(name));
  await Promise.all(obsolete.map((name) => cacheStorage.delete(name)));

  return obsolete;
}
